import { datadogRum } from '@datadog/browser-rum';

export function initDatadogRum() {
  const environment = window.datadogRumConfig?.env;

  if (!environment || !['development', 'beta', 'preview', 'production'].includes(environment)) {
    console.log('Datadog RUM disabled for this environment');
    return;
  }

  const config = window.datadogRumConfig || {};

  if (!config.applicationId || !config.clientToken) {
    console.error('Datadog RUM: Missing applicationId or clientToken');
    return;
  }

  datadogRum.init({
    applicationId: config.applicationId,
    clientToken: config.clientToken,
    site: config.site || 'datadoghq.com',
    service: config.service || 'cw-rails-identity-provider',
    env: config.env,
    version: config.version || '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}
